module.exports = __webpack_public_path__ + "img/img_cno_tno.13b5e109.webp";